class ComponentStickyNavigation extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.toggle = this.querySelector('.sticky-nav-toggle');
    this.openIcon = this.querySelector('.sticky-nav-open');
    this.closeIcon = this.querySelector('.sticky-nav-close');
    this.menu = this.querySelector('.sticky-nav-menu');

    if (!this.toggle || !this.openIcon || !this.closeIcon || !this.menu) return;

    this.isOpen = false;

    // Close by default on mobile; desktop is controlled by CSS.
    this.menu.style.maxHeight = '0';
    this.menu.style.overflow = 'hidden';

    this._onToggleClick = this.handleToggleClick.bind(this);
    this.toggle.addEventListener('click', this._onToggleClick);
  }

  disconnectedCallback() {
    if (this.toggle && this._onToggleClick) {
      this.toggle.removeEventListener('click', this._onToggleClick);
    }
  }

  openMenu() {
    this.isOpen = true;
    this.menu.classList.add('pb-16');
    this.classList.add('gap-3.2');
    this.menu.style.maxHeight = this.menu.scrollHeight + 40 + 'px';
    this.openIcon.classList.add('hidden');
    this.closeIcon.classList.remove('hidden');
  }

  closeMenu() {
    this.isOpen = false;
    this.menu.style.maxHeight = '0';
    this.menu.classList.remove('pb-16');
    this.closeIcon.classList.add('hidden');
    this.openIcon.classList.remove('hidden');

    setTimeout(() => {
      this.classList.remove('gap-3.2');
    }, 300);
  }

  handleToggleClick() {
    if (this.isOpen) {
      this.closeMenu();
      return;
    }

    this.openMenu();
  }
}

if (!customElements.get('component-sticky-navigation')) {
  customElements.define('component-sticky-navigation', ComponentStickyNavigation);
}
